import { Component, input, ChangeDetectionStrategy, contentChild, TemplateRef, computed, signal } from '@angular/core';
import { WidgetContainerComponent } from '../widget-container/widget-container.component';
import { NgTemplateOutlet } from '@angular/common';
import { WidgetContainer } from '../../directives/widget-container';
import { WidgetTemplateRef } from '../../../../interfaces/view-widget/widget-ref';
import { ViewWidget, ListWidgetConfig } from '../../../../interfaces/view-widget';
import { LIST_WIDGET_LAYOUT } from '../../constants';

@Component({
  selector: 'ol-list-widget',
  templateUrl: './list-widget.component.html',
  styleUrls: ['./list-widget.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgTemplateOutlet, WidgetContainerComponent],
})
export class ListWidgetComponent extends WidgetContainer {
  title = input<string>('');
  headerLink = input<string>('');
  headerActionTemplate = input<TemplateRef<unknown> | null>(null);
  disableViewportLogic = input<boolean>(false);
  layoutConfig = input<ListWidgetConfig>({
    itemsPerRow: LIST_WIDGET_LAYOUT.ITEMS_PER_ROW,
    rowGap: LIST_WIDGET_LAYOUT.ROW_GAP,
    columnGap: LIST_WIDGET_LAYOUT.COLUMN_GAP,
  });

  itemTemplate = contentChild<WidgetTemplateRef>(TemplateRef);

  private readonly adaptiveMaxWidgets = signal<number | undefined>(undefined);

  containerStyles = computed(() => {
    const config = this.layoutConfig();
    return config
      ? {
          display: 'grid',
          'grid-template-columns': `repeat(${config.itemsPerRow}, 1fr)`,
          gap: `${config.rowGap}px ${config.columnGap}px`,
        }
      : {};
  });

  protected override getProcessedWidgets(widgets: ViewWidget[], maxItems?: number): ViewWidget[] {
    if (this.disableViewportLogic()) {
      return this.widgetsDisplayService.prepareListWidgets(widgets, widgets.length);
    }

    const effectiveMaxItems = this.adaptiveMaxWidgets() ?? maxItems ?? widgets.length;
    return this.widgetsDisplayService.prepareListWidgets(widgets, effectiveMaxItems);
  }

  // onViewportChange(dimensions: ViewportDimensions): void {
  //   super.onViewportChange(dimensions);
  //
  //   if (this.disableViewportLogic()) {
  //     this.adaptiveMaxWidgets.set(undefined);
  //     return;
  //   }
  //
  //   const widgets = this.widgets();
  //   if (!widgets || widgets.length === 0) {
  //     this.adaptiveMaxWidgets.set(undefined);
  //     return;
  //   }
  //
  //   const config = this.layoutConfig();
  //   const gap = config.rowGap || LIST_WIDGET_LAYOUT.ROW_GAP;
  //   const itemsPerRow = config.itemsPerRow || LIST_WIDGET_LAYOUT.ITEMS_PER_ROW;
  //
  //   const maxRowsByHeight = this.widgetsDisplayService.calculateWidgetsByHeight(
  //     dimensions.availableHeight,
  //     gap,
  //   );
  //
  //   const maxWidgetsByHeight = maxRowsByHeight * itemsPerRow;
  //
  //   this.adaptiveMaxWidgets.set(
  //     maxWidgetsByHeight > 0 ? maxWidgetsByHeight : undefined,
  //   );
  // }
}
